const recurrings = {
  id: 'id',
  contact_id: 'Contact',
  title: 'Titre',
  contact_first_name: 'Prénom',
  contact_last_name: 'Nom',
  contact_company_name: 'Compagnie',
  contact_email: 'Courriel',
  amount: 'Montant',
  frequency: 'Fréquence',
  start_date: 'Date de début',
  next_date: 'Prochaine date',
  end_date: 'Date de fin',
  state: 'Statut',
  create_invoice: 'Créer facture',
  create_payment: 'Créer paiement',
  send_invoice_by_email: 'Envoyer facture par courriel',
  source: 'Source',
  last_invoice_status: 'Dernier statut facture',
  last_payment_status: 'Dernier statut paiement',
  invoice_counter: 'Nb factures',
  payment_counter: 'Nb paiements',
  invoice_failure_count: 'Échecs facture',
  payment_failure_count: 'Échecs paiement',
  payment_info: 'Méthode de paiement',
  invoice_id: 'Facture',
  payment_id: 'Paiement',
  template_invoice: 'Facture modèle',
  edit_template_invoice: 'Modifier la facture modèle',
};

export default recurrings;
